export const VOICE_CALL_LABELS = {
  panelTitle: 'Spark Voice',
  callTitle: 'Call Spark',
  callBlurb: 'Talk with Spark about your Voyager knowledge.',
  mute: 'Mute',
  unmute: 'Unmute',
  speaker: 'Speaker',
  endCall: 'End',
  productName: 'AI Voice Assistant',
  callEnded: 'Call ended.',
  connecting: 'Connecting…',
  connected: 'Connected — speak to Spark',
  tapToCall: 'TAP TO CALL',
  tapToEndCall: 'TAP TO END CALL',
  callDuration: 'CALL DURATION',
  openCallAria: 'Open voice call',
  closeAria: 'Close voice call',
  muteAria: 'Mute microphone',
  unmuteAria: 'Unmute microphone',
  speakerAria: 'Toggle speaker',
  tokenFailed: 'Could not start call. Please try again.',
  micDenied: 'Microphone access is required for voice calls.',
  wsDisconnected: 'Live updates disconnected. Retrying…',
  user: 'You',
  ai: 'Spark',
  liveTranscript: 'Live transcript',
} as const;

export const TWILIO_CONNECT_TARGET = 'agent';

// Relative to environment.pythonUrl (origin + '/ai').
export const CLIENT_STREAM_PATH = '/voice/client-stream';

export const TOKEN_PATH = '/voice/token';

export const WS_RECONNECT_BASE_MS = 1000;

export const WS_RECONNECT_MAX_MS = 30000;
